import axios from 'axios';
import { accountEvents } from '../../model/accountevents.js';
import { appStartTime } from '../../model/app-start-time.js';

export default {
	namespaced: true,
	state: {
        events: [],
        eventsChat:[],
        eventsStream:[],
        sortEvents:[]
	},
	getters: {
		events(state) {
			return state.events;
        },
        eventsChat(state) {
			return state.eventsChat;
        },
        getSortEvents(state) {
            return state.sortEvents;
        },
        getApiUri(state, getters, rootState, rootGetters) {
            return rootGetters['api/getApiUri'];
        },
        getStreamEvent(state) {
            return state.eventsStream
        }
	},
	mutations: {
		addEventsRange(state, evts) {
			for (let i = 0; i < evts.length; i++)
                state.events.push(evts[i]);  
        },
        setEventsStream(state, data) {
            if(!data)
                return
            let arr = []
            for(let key in data) {
                for(let i=0; i < data[key].length; i++)
                arr.push(data[key][i])
            }
            state.eventsStream = arr.sort(compareStream);
        },
        sortEventsRange(state) {
            state.events.sort(compareNumbers);
        },
        addEventsRangeChat(state, evts) {
			for (let i = 0; i < evts.length; i++)
				state.eventsChat.push(evts[i]);
        },
        caruselEvents(state) {
            state.eventsChat = [];
        }
	},
	actions: {
		subscribeOnPositionEvents(state) {
			accountEvents.subscribeOnPosOpened('acEvtsStore', (evts) => {
				evts.forEach(p => { p.eventType = 'open'; });
                state.commit('addEventsRange', evts);
                state.commit('addEventsRangeChat', evts);
			});
			accountEvents.subscribeOnPosClosed('acEvtsStore', (evts) => {
				evts.forEach(p => { p.eventType = 'close'; });
                state.commit('addEventsRange', evts);
                state.commit('addEventsRangeChat', evts);
                state.commit('sortEventsRange');
            });
			accountEvents.readLastEvents();
        },
        sorting(state) {
            state.commit('sortEventsRange');
        },
        evetntsForStream(store) {
            let lastTime = appStartTime.getLastTime();
            let stamp = lastTime.getTime()/1000 - 60*1440*10;
            let uri = store.getters['getApiUri'] + 'statistics/bytimestamp?accountIds=949&time=' + stamp;
            axios.get(uri).then(
                response => {
                    store.commit('setEventsStream', response.data);
                }
            )
        }
	}
}

function compareNumbers(a, b) {
    let srt1 = null;
    let str2 = null;
    a.eventType === 'close' ? srt1 = a.timeExit.replace(/\./g,'-') : srt1 = a.timeEnter.replace(/\./g,'-');
    b.eventType === 'close' ? str2 = b.timeExit.replace(/\./g,'-') : str2 = b.timeEnter.replace(/\./g,'-');
    return  new Date(str2).getTime() - new Date(srt1).getTime();
  }

  function compareStream(a, b) {
    let srt1 = null;
    let str2 = null;
    a.timeExit ? srt1 = a.timeExit : srt1 = a.timeEnter;
    b.timeExit ? str2 = b.timeExit : str2 = b.timeEnter;
    return  new Date(str2).getTime() - new Date(srt1).getTime();
  }
